<template>
  <header>
    <div class="header" :class="isHome">
      <div class="header__block">
        <router-link class="header__logo" to="/">
          <img src="@/assets/images/logo.png" alt="logo" />
          <img v-if="$DEV === '1'" src="@/assets/images/dev.svg" alt="dev" />
        </router-link>

        <div class="header__search">
          <div class="header-search">
            <el-input
              v-model="searchContent"
              :placeholder="$t('header.search.placeholder')"
            />
            <el-button
              :loading="isSearching"
              @click="Search()"
            >
              <i class="fa fa-search" aria-hidden="true" />
            </el-button>
          </div>
        </div>

        <div class="header__menu">
          <div class="header-menu">
            <router-link
              v-for="item in headerMenu"
              :to="item.url"
              :key="item.url"
              class="header-menu__item"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>

        <div class="header__tool">
          <!-- 語言切換 -->
          <div class="header-language">
            <el-dropdown @command="changeLocale" placement="bottom">
              <i class="fa fa-globe fa-lg" aria-hidden="true"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="lang in languages"
                  :key="lang.code"
                  :command="lang.code"
                  :class="{ 'is-active': $i18n.locale === lang.code }"
                >
                  <span>{{ $t(lang.label) }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- 購物車 -->
          <router-link class="header-cart" to="/shopping/step1">
            <i class="fa fa-shopping-cart fa-lg" aria-hidden="true"></i>
            <span class="header-num">{{ getCartCount }}</span>
          </router-link>

          <!-- 會員 -->
          <a
            v-if="userAccount"
            class="header-member"
          >
            <i class="fa fa-user fa-lg" aria-hidden="true"></i>
            <!-- <span class="header-num">{{ unReadCount }}</span> -->

            <div class="header-member__box">
              <div class="header-member__list">
                <router-link
                  v-for="item in userMenu"
                  :to="item.url"
                  :key="item.url"
                  class="header-member__link"
                >
                  {{ item.title }}
                </router-link>
              </div>
            </div>
          </a>

          <router-link
            v-if="!userAccount"
            class="header-login"
            to="/login"
          >
            <span>{{ $t('common.button.login') }}</span>
          </router-link>

          <a
            v-if="userAccount"
            class="header-login"
            @click.prevent="Logout()"
          >
            <span>{{ $t('common.button.logout') }}</span>
          </a>

          <el-button
            @click="isDrawer = true"
            type="primary"
            class="header-button"
          >
            <i class="fa fa-bars" />
          </el-button>
        </div>
      </div>

      <!-- 手機版選單 -->
      <el-drawer
        :visible.sync="isDrawer"
        :direction="'rtl'"
      >
        <div class="side__search">
          <div class="header-search">
            <i class="fa fa-search" aria-hidden="true" />
            <el-input
              v-model="searchContent"
              :placeholder="$t('header.search.placeholder')"
            />
            <el-button
              :loading="isSearching"
              @click="Search()"
            >
              {{ $t('common.button.search') }}
            </el-button>
          </div>
        </div>

        <div class="side__menu">
          <div class="side-menu">
            <template v-for="(item, idx) in sideMenu">
              <router-link
                v-if="item.type === 'in'"
                :to="item.url"
                :key="`${ item.url }_side`"
                class="side-menu__item"
                @click.native="closeSide"
              >
                {{ item.title }}
              </router-link>

              <a
                v-else-if="item.type === 'event'"
                :key="`event_${ idx }`"
                class="side-menu__item"
                @click="item.action"
              >
                {{ item.title }}
              </a>
              <!-- 可展開的群組（用於語系） -->
              <div v-else-if="item.type === 'group'" :key="`group_${ idx }`" class="side-menu__group">
                <div class="side-menu__item side-menu__group-toggle" @click="sideLangOpen = !sideLangOpen">
                  <span>{{ item.title }}</span>
                  <i class="fa" :class="sideLangOpen ? 'fa-chevron-down' : 'fa-chevron-right'" />
                </div>

                <div v-if="sideLangOpen" class="side-menu__group-children">
                  <div v-for="(child, cidx) in item.children" :key="`child_${ cidx }`">
                    <router-link
                      v-if="child.type === 'in'"
                      :to="child.url"
                      :key="`${ child.url }_child`"
                      class="side-menu__item side-menu__child"
                      @click.native="closeSide"
                    >
                      {{ child.title }}
                    </router-link>

                    <a
                      v-else-if="child.type === 'event'"
                      :key="`child_event_${ cidx }`"
                      class="side-menu__item side-menu__child"
                      @click="handleChildAction(child)"
                    >
                      {{ child.title }}
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </el-drawer>
    </div>
  </header>
</template>

<script>
import { Logout } from '@/api/LoginApi';
import { GetMessageUnReadCount } from '@/api/MemberApi';
import { GetShoppingCartCount, AddShoppingCart } from '@/api/ShoppingCartApi';

/* global $ */
export default {
  data() {
    return {
      isSearching: false,
      isDrawer: false,

      headerMenu: [
        // {
        //   type: 'in',
        //   title: '購買課程',
        //   url: '/course',
        // },
        // {
        //   type: 'in',
        //   title: '預約講堂',
        //   url: '/bookings',
        // },
        // {
        //   type: 'in',
        //   title: '師資團隊',
        //   url: '/teachers',
        // },
        // {
        //   type: 'in',
        //   title: '測驗去',
        //   url: '/practices',
        // },
        {
          type: 'in',
          title: this.$t('header.menu.myCourses'),
          url: '/learnings',
        },
      ],
      userMenu: [
        {
          type: 'in',
          title: this.$t('header.user.orders'),
          url: '/member/orders',
        },
        {
          type: 'in',
          title: this.$t('header.user.info'),
          url: '/member/info',
        },
        {
          type: 'in',
          title: this.$t('header.user.changePassword'),
          url: '/member/changePassword',
        },
      ],
      logout: {
        type: 'event',
        title: this.$t('common.button.logout'),
        action: () => {
          this.Logout();
        },
      },
      login: {
        type: 'in',
        title: this.$t('common.button.login'),
        url: '/login',
      },

      // 語言列表配置
      languages: [
        { code: 'zh-TW', label: 'header.language.zhTW' },
        { code: 'en', label: 'header.language.en' },
        { code: 'vi', label: 'header.language.vi' },
        { code: 'my', label: 'header.language.my' },
        { code: 'id', label: 'header.language.id' },
        { code: 'ja', label: 'header.language.ja' },
        { code: 'km', label: 'header.language.km' },
      ],

      sideLanguage: [
        {
          type: 'event',
          title: this.$t('header.language.zhTW'),
          action: () => {
            this.changeLocale('zh-TW');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.en'),
          action: () => {
            this.changeLocale('en');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.vi'),
          action: () => {
            this.changeLocale('vi');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.my'),
          action: () => {
            this.changeLocale('my');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.id'),
          action: () => {
            this.changeLocale('id');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.ja'),
          action: () => {
            this.changeLocale('ja');
          },
        },
        {
          type: 'event',
          title: this.$t('header.language.km'),
          action: () => {
            this.changeLocale('km');
          },
        },
      ],

      // 控制手機版語系群組是否展開
      sideLangOpen: false,

      userAccount: '',
      searchContent: '',
      activeSearch: '',
      unReadCount: 0,
      getUnReadCounting: 0,
      getCartCount: 0,
    };
  },
  computed: {
    sideMenu() {
      const base = this.userAccount
        ? [...this.headerMenu, ...this.userMenu, this.logout]
        : [...this.headerMenu, this.login];

      // 把語系放在一個可展開的群組中，mobile drawer 會顯示折疊面板
      return [
        ...base,
        // {
        //   type: 'group',
        //   title: this.$t('header.language.translations') || 'Translations',
        //   children: this.sideLanguage,
        // },
      ];
    },
    isHome() {
      if (this.$route.meta.title === '首頁') {
        return 'is-home';
      }

      return '';
    },
  },
  created() {
    // ('對應傳送端的emit方法','接收的參數')
    this.$bus.$on('setUserAccount', (val) => {
      this.SetUserAccount(val);
    });

    // ('對應傳送端的emit方法','接收的參數')
    this.$bus.$on('getUnReadCount', (force) => {
      this.GetMessageUnReadCount(force);
    });

    // ('對應傳送端的emit方法','接收的參數')
    this.$bus.$on('getShoppingCartCount', () => {
      this.GetShoppingCartCount();
    });

    // ('對應傳送端的emit方法','接收的參數')
    this.$bus.$on('addShoppingCart', (id) => {
      this.AddShoppingCart(id);
    });
  },
  mounted() {
    this.$setUserAccount();

    if (this.userAccount !== '') {
      this.GetMessageUnReadCount();
      this.GetShoppingCartCount();
    }

    // eslint-disable-next-line no-undef
    $(window).on('scroll resize', () => {
      const headerHeight = $(window).width() > 991 ? 20 : 60;
      const windowTop = $(window).scrollTop();

      if ($('.header').length) {
        if (windowTop < headerHeight) {
          $('.header').removeClass('header--scroll');
        }

        if (windowTop >= headerHeight) {
          $('.header').addClass('header--scroll');
        }
      }
    });
  },
  methods: {
    SetUserAccount(val) {
      this.userAccount = val;
      if (val === '') this.getCartCount = 0;
    },
    Search() {
      if (this.searchContent.length < 2) {
        this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('common.message.searchMinLength'),
        });
      } else if (this.activeSearch !== this.searchContent || this.$route.name !== 'Search') {
        this.activeSearch = this.searchContent;
        this.$router.push({ path: '/Search', query: { searchContent: this.activeSearch } });
        this.isDrawer = false;
      } else {
        // 當在搜尋結果頁面，使用相同條件再次搜尋的話
        this.$bus.$emit('reSearchCourse', this.searchContent);
      }
    },
    Logout() {
      return Logout().then((res) => {
        if (res.data.statusCode === 0) {
          this.isDrawer = false;

          this.$message({
            showClose: true,
            type: 'success',
            message: res.data.message,
          });
          const temp = new Date();
          const d = new Date(temp.setDate(temp.getDate() - 1));
          document.cookie = `token=;expires=${d}; path=/`;
          document.cookie = `CloudFront-Policy=; expires=${d}; path=/`;
          document.cookie = `CloudFront-Key-Pair-Id=; expires=${d}; path=/`;
          document.cookie = `CloudFront-Signature=; expires=${d}; path=/`;
          this.$setUserAccount();
          // this.GetShoppingCartCount();
          if (this.$route.path !== '/') this.$router.push('/');
        }
      });
    },
    handleChildAction(child) {
      if (child && typeof child.action === 'function') {
        child.action();
      }
      this.closeSide();
    },
    AddShoppingCart(id) {
      this.$setUserAccount();
      if (this.userAccount !== '') {
        AddShoppingCart(id).then((response) => {
          if (response.data.statusCode === 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('common.message.addToCartSuccess'),
            });
          }
          this.GetShoppingCartCount();
        });
      } else {
        this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('common.message.pleaseLogin'),
        });
      }
    },
    GetShoppingCartCount() {
      this.$setUserAccount();
      if (this.userAccount !== '') {
        GetShoppingCartCount().then((response) => {
          if (response.data.statusCode === 0) {
            this.getCartCount = response.data.data;
          }
        });
      } else {
        this.getCartCount = 0;
      }
    },
    GetMessageUnReadCount(force = false) {
      this.$setUserAccount();
      if (this.userAccount !== '') {
        if (this.getUnReadCounting === 0 || force === true) {
          this.getUnReadCounting = 1;

          GetMessageUnReadCount().then((response) => {
            if (response.data.statusCode === 0) {
              this.unReadCount = response.data.data;
            }
          });

          // 避免短時間一直重新取得
          setTimeout(() => {
            this.getUnReadCounting = 0;
          }, 30000);
        }
      }
    },
    closeSide() {
      this.isDrawer = false;
    },
    changeLocale(locale) {
      this.sideLangOpen = false;
      // 如果語系與當前相同就不做任何動作
      if (this.$i18n.locale === locale) return;

      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);

      // 更新選單文字（reload 之前更新以防在不 reload 的情況下需要即時更新）
      this.headerMenu = [
        {
          type: 'in',
          title: this.$t('header.menu.myCourses'),
          url: '/learnings',
        },
      ];
      this.userMenu = [
        {
          type: 'in',
          title: this.$t('header.user.orders'),
          url: '/member/orders',
        },
        {
          type: 'in',
          title: this.$t('header.user.info'),
          url: '/member/info',
        },
        {
          type: 'in',
          title: this.$t('header.user.changePassword'),
          url: '/member/changePassword',
        },
      ];
      this.logout = {
        type: 'event',
        title: this.$t('common.button.logout'),
        action: () => {
          this.Logout();
        },
      };
      this.login = {
        type: 'in',
        title: this.$t('common.button.login'),
        url: '/login',
      };

      // 關閉手機抽屜（避免在 reload 前產生短暫的 UI 側滑）
      this.isDrawer = false;
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(#aaa, .1);
  z-index: 9999;

  &::before {
    content: "";

    display: none;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(#000, .5);
    backdrop-filter: blur(10px);

    z-index: -1;
  }

  &.header--scroll {
    &::before {
      display: block;
    }

    .header-menu__item,
    .header-language i,
    .header-cart,
    .header-member {
      color: #fff;

      &:hover {
        color: var(--primary-color);
      }
    }

    .header-button {
      background-color: #fff;

      i {
        color: var(--primary-color);
      }
    }
  }

  /deep/ .el-drawer {
    width: 240px !important;

    &__header {
      margin-bottom: 0;
      padding: 5px 15px;

      background-color: #f1f1f1;
    }

    &__close-btn {
      i {
        font-weight: 700;
        color: var(--primary-color);
      }
    }
    &__body {
      /* remove default padding so our items can span full width */
      padding: 0 !important;
    }
  }

  .side {
    &__menu {
      overflow-y: auto;
      max-height: calc(100dvh - 100px);
      padding: 0;
    }

    &-menu {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      &__item {
        display: block;

        width: 100%;
        padding: 10px 24px;

        font-size: 15px;
        font-weight: 700;
        color: var(--primary-color);

        border-bottom: 1px solid #f1f1f1;

        &:active,&.router-link-active {
          color: #fff;

          background-color: var(--primary-color);
        }
      }
    }
  }

  /* Ensure side menu items and groups occupy full width so border-bottom spans correctly */
  .side-menu,
  .side-menu__group,
  .side-menu__group-children,
  .side-menu__item,
  .side-menu__child,
  .side-menu__group-toggle {
    width: 100%;
    box-sizing: border-box;
  }

  /* Make sure links are block-level and fill the container */
  .side-menu__item,
  .side-menu__child,
  .side-menu__group-toggle {
    display: block;
  }

  /* Remove extra spacing from inner wrappers so border lines align */
  .side-menu__group-children > div {
    padding: 0;
    margin: 0;
  }

  .side-menu__group-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 24px;
    font-size: 15px;
    font-weight: 700;
    color: var(--primary-color);
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
  }

  .side-menu__group-children {
    display: flex;
    flex-direction: column;
  }

  .side-menu__child {
    padding-left: 36px;
    font-weight: 500;
    border-bottom: 1px solid #f1f1f1;
  }

  &__block {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    width: 100%;
    max-width: calc(var(--container-l-width) + (var(--container-padding) * 2));
    height: 70px;
    padding: 0 var(--container-padding);
    margin: 0 auto;

    @media (max-width: 991px) {
      max-width: 100%;
      height: 60px;
      margin: 0;
    }
  }

  &__logo {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;

    height: 50px;

    img {
      display: block;

      max-width: 100%;

      &:nth-child(2) {
        width: 40px;
        height: 40px;

        @media (max-width: 991px) {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  &__search {
    margin: 0 20px;

    @media (max-width: 991px) {
      display: none;
    }
  }

  &__menu {
    flex: 1;

    @media (max-width: 991px) {
      display: none;
    }
  }

  &__tool {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;

    margin-left: 30px;

    @media (max-width: 991px) {
      margin-left: auto;
    }
  }

  &-search {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 5px 12px;

    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #eee;

    @media (max-width: 991px) {
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #ccc;
    }

    &:focus-within {
      border-color: var(--primary-color);
    }

    /deep/ .el-input {
      margin-right: 8px;
      max-width: 200px;

      @media (max-width: 991px) {
        max-width: 100%;
        margin-left: 8px;
      }

      &__inner {
        height: 28px;
        padding: 2px;

        line-height: 28px;
        font-size: 15px;
        color: #667085;

        border: none;

        &::placeholder {
          font-size: 14px;
          color: #c9c6c6;
        }
      }
    }

    /deep/ .el-button {
      padding: 7px 12px;

      line-height: 1;
      color: var(--primary-color);

      background-color: #fff;

      border: none;
      border-radius: 8px;

      transition-property: background-color;
      transition-duration: .3s;
      transition-timing-function: linear;

      &:hover {
        background-color: var(--primary-light-color);
      }
    }
  }

  &-menu {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &__item {
      line-height: 1.2;
      font-size: 16px;
      font-weight: 500;
      color: #333;

      &:hover {
        color: var(--primary-color);
      }

      &:active {
        color: var(--primary-color);
      }

      &:nth-of-type(n + 2) {
        margin-left: 10px;
      }
    }
  }

  &-language {
    position: relative;
    display: block;
    height: 24px;
    font-size: 16px;

    cursor: pointer;

    i.fa-globe {
      cursor: pointer;
      transition: color 0.3s;
      color: #3C3737;

      @media (max-width: 991px) {
        font-size: 22px;
      }

      &:hover {
        color: var(--primary-color);
      }
    }
  }

  &-cart, &-member {
    position: relative;
    display: block;
    height: 24px;
    font-size: 16px;
    color: #3C3737;
    transition: color 0.3s;

    cursor: pointer;

    &:hover {
      i {
        color: var(--primary-color);
      }
    }
  }

  &-member {
    @media (max-width: 991px) {
      display: none;
    }

    &:hover {
      .header-member__box {
        display: block;
      }
    }

    &__box {
      display: none;

      position: absolute;
      top: 100%;
      left: 0;

      width: 150px;
      padding-top: 22px;

      transform: translateX(-50%);
    }

    &__list {
      background-color: #fff;

      border-radius: 0 0 4px 4px;

      box-shadow: 0 3px 5px rgba(16, 24, 40, .15)
    }

    &__link {
      display: block;
      padding: 8px 20px;
      font-size: 15px;
      text-align: center;

      &:hover {
        background-color: #f1f1f1;
      }
    }
  }

  &-login {
    display: flex;
    justify-content: center;
    align-items: center;

    min-width: 60px;
    height: 40px;
    padding: 0 12px;

    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    color: var(--primary-color);

    background-color: #fff;
    border-radius: 8px;
    border: 1px solid var(--primary-color);

    transition-property: 'border-color, color';
    transition-duration: .3s;
    transition-timing-function: linear;

    cursor: pointer;

    @media (max-width: 991px) {
      display: none;
    }

    &:hover {
      background-color: var(--primary-color);
      color: #fff;
    }
  }

  &-button {
    width: 32px;
    height: 32px;
    padding: 8px 10px;

    background-color: var(--primary-color);
    border-color: var(--primary-color);

    &:hover, &:focus {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
    }

    @media (min-width: 992px) {
      display: none;
    }
  }

  &-num {
    position: absolute;
    top: 0;
    right: -5px;
    display: flex;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 9px;
    color: #fff;
    border-radius: 50%;
    background-color: red;
  }
}

/deep/ .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 16px;
  font-size: 14px;
  transition: all 0.3s;

  i.fa-check {
    color: var(--primary-color);
    font-size: 14px;
    min-width: 14px;
  }

  &.is-active {
    background-color: var(--primary-light-color);
    color: var(--primary-color);
    font-weight: 600;
  }

  &:hover {
    background-color: var(--primary-light-color);
    color: var(--primary-color);
  }
}
</style>
